// const base = 'http://localhost:8000'
const base = 'https://api-kcal.nicolasrz.me';


export {base}